import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { initMetaPixel } from './lib/metaPixel';
// Initialize Meta Pixel as early as possible — before React mounts.
// This ensures PageView fires immediately and matches Meta's recommended
// placement (as if it were in <head> of index.html).
initMetaPixel();
render(<App data-id="element-205" />, document.getElementById('root'));